import { useState } from 'react'

import type { FilterValue, FilterValues } from '@lib/types'

type CheckboxDropdownParams = {
	field: string
	options: FilterValues
	onChangeHandler: (checked: boolean, value: FilterValue) => void | undefined
}

export default function CheckboxDropdown({
	field,
	options,
	onChangeHandler
}: CheckboxDropdownParams) {
	const [open, toggle] = useState(false)

	return (
		<div className="pt-2 pb-4">
			<button
				type="button"
				className="flex justify-between w-full py-1 font-medium"
				onClick={() => toggle((prev) => !prev)}
			>
				{field}
				<span className={`transition duration-300 ease-in-out ${open ? 'rotate-180' : 'rotate-0'}`}>
					<i className="fa-regular fa-angle-down text-gray-500" />
				</span>
			</button>

			{Array.isArray(options) && (
				<div className={`pt-3 pb-4 space-y-4 ${open ? '' : 'hidden'}`}>
					{options.map((option: FilterValue, index: number) =>
						option ? (
							// eslint-disable-next-line react/no-array-index-key
							<div className="flex gap-2.5" key={`dropdown-${index}-item-${option.id}`}>
								<input
									type="checkbox"
									id={option.id}
									name={option.label}
									onChange={(e) => onChangeHandler(e.target.checked, option)}
									className="checkbox w-3.5 h-3.5 mt-0.5 border-gray-350 border-2 text-bbx-spark rounded-sm focus:ring-bbx-spark/40 focus:ring-2 focus:ring-offset-0 focus:border-0"
								/>
								<label htmlFor={option.id} className="font-light leading-5">
									{option.label}
								</label>
							</div>
						) : null
					)}
				</div>
			)}
		</div>
	)
}
